import React from 'react';
import { uploadDeliveablesSchema } from '../../../utils/schema';
import { Formik } from 'formik';
import ErrorMessage from '../../form/ErrorMessage';
import PdfOrImageUploader from '../../pdfImage uploader';

const UploadDeliveableModal = ({ onClose, handleUploadDeliveablesData }) => {

    const initialState = {
        files: "",
        link: "",
        comment: ""
    };

    return (
        <div
            className="modal d-block ct_congratulation_modal_fade"
            tabIndex="-1"
        >
            <div
                class="modal-dialog modal-dialog-centered ct_modal-dialog"
                style={{ maxWidth: "700px" }}
            >
                <div class="modal-content ct_p_30 ct_border_radius_20">
                    <div class="modal-header border-0 p-0 ct_mb_30">
                        <div>
                            <h4 class="mb-1 ct_fs_20">Upload Deliverable</h4>
                            <p class="mb-0 ct_grey_text">
                                Submit completed work or progress files for the client to
                                review
                            </p>
                        </div>
                        <button
                            type="button"
                            class="btn-close ct_circle_close"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body p-0">
                        <Formik
                            initialValues={initialState}
                            validationSchema={uploadDeliveablesSchema}
                            onSubmit={(values, actions) => {
                                handleUploadDeliveablesData(values);
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setTouched,
                                setFieldValue
                            }) => (
                                <form>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div class="form-group ct_mb_20">
                                                <label class="ct_fs_14 ct_darkblue_text mb-2">
                                                    Upload Deliverable Files
                                                </label>
                                                <PdfOrImageUploader
                                                    maxFiles={20}
                                                    multiple={true}
                                                    acceptType=".zip,application/zip"
                                                    placeholder="Upload Project ZIP files"
                                                    existingFiles={
                                                        values?.files &&
                                                            Array.isArray(values.files)
                                                            ? values.files.map((file, idx) => ({
                                                                id: idx,
                                                                file:
                                                                    typeof file === "string"
                                                                        ? file
                                                                        : URL.createObjectURL(file),
                                                                name: file.name || `project-${idx}.zip`,
                                                                type: "zip",
                                                            }))
                                                            : []
                                                    }
                                                    onChange={(newFiles) => {
                                                        setTouched({ files: true });
                                                        setFieldValue("files", newFiles); // store array of files
                                                    }}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"files"}
                                                />
                                            </div>
                                            <div class="form-group ct_mb_20">
                                                <label class="ct_fs_14 ct_darkblue_text mb-2">
                                                    Link (Optional)
                                                </label>
                                                <input
                                                    class="form-control ct_input ct_fs_12"
                                                    placeholder="Enter Link"
                                                    id="link"
                                                    value={values?.link}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName="link"
                                                />
                                            </div>
                                            <div class="form-group ct_mb_20">
                                                <label class="ct_fs_14 ct_darkblue_text mb-2">
                                                    Message to Client (Optional)
                                                </label>
                                                <textarea
                                                    class="form-control ct_input h-auto ct_fs_12"
                                                    rows={4}
                                                    placeholder="Write your comment or update here...."
                                                ></textarea>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName="comment"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center gap-3 justify-content-end ">
                                        <button
                                            class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                                            type="button"
                                            onClick={onClose}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            class="ct_yellow_btn px-5 ct_h_44"
                                            type="button"
                                            onClick={handleSubmit}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default UploadDeliveableModal;